var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('the-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isWaiting),expression:"isWaiting"}]}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }